module.exports = __webpack_public_path__ + "staticcomp/img/preview_bt.51739b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/preview_bt.png
// module id = aPdN
// module chunks = 39